import React, { FC, forwardRef, RefObject, useEffect, useRef, useState } from 'react';
import intlTelInput from 'intl-tel-input';
import styled, { css } from 'styled-components';
import { BaseFormProps, StyledBase } from './Base';
import { FormField, FormFieldProps } from './FormField';
import { useForwardedRef } from '../../hooks/useForwardedRef';
import 'intl-tel-input/build/css/intlTelInput.css';
import { getOffsetSpace } from '../../utils/getOffsetSpace';

export interface InputProps extends BaseFormProps, FormFieldProps {
  onChange: (...event: any[]) => void;
  value?: string;
}

const StyledFormField = styled(FormField)`
  ${({ theme: { borders, space } }) => css`
    .iti {
      width: 100%;
      display: flex;

      flex-direction: row;
      flex-wrap: nowrap;
    }
    .iti__flag-container {
      flex-shrink: 0;
      position: static;
    }
    .iti--separate-dial-code .iti__selected-flag {
      border: ${borders.default};
      background-color: #fff;
      margin-right: ${space.sm};
    }

    .iti input,
    .iti input[type='text'],
    .iti input[type='tel'] {
      &[style] {
        padding: ${getOffsetSpace(space.md)} !important; // library forces padding-left to YOLO
      }
    }
  `};
`;
export const PhoneNumberInput: FC<InputProps> = forwardRef(
  (
    {
      label,
      id,
      tooltipText,
      tooltipInfoIcon,
      valid,
      invalid,
      constrained,
      placeholder,
      required,
      value = '',
      onChange,
      ...rest
    },
    ref
  ) => {
    const safeRef = useForwardedRef(ref);
    const intlTel = useRef<any>();
    const [inputValue, setInputValue] = useState(value);

    // update field value on change
    const handleOnChange = (event: any) => {
      setInputValue(event.target.value);
      if (onChange) {
        onChange(`${intlTel?.current?.selectedCountryData.dialCode} ${event.target.value}`);
      }
    };
    useEffect(() => {
      // initialise plugin
      if (!intlTel.current && safeRef?.current) {
        intlTel.current = intlTelInput(safeRef.current, {
          nationalMode: false,
          preferredCountries: ['gb', 'us'],
          separateDialCode: true,
          initialCountry: 'gb',
        });
      }
    }, [safeRef]);

    return (
      <StyledFormField
        label={label}
        htmlFor={id}
        tooltipText={tooltipText}
        tooltipInfoIcon={tooltipInfoIcon}
        required={required}
        invalid={invalid}
        {...rest}
      >
        <StyledBase
          as="input"
          type="tel"
          id={id}
          name={id}
          valid={valid}
          value={inputValue}
          invalid={invalid}
          ref={safeRef as RefObject<HTMLInputElement>}
          placeholder={placeholder}
          constrained={constrained}
          onChange={handleOnChange}
        />
      </StyledFormField>
    );
  }
);

export default PhoneNumberInput;
